var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-nav"}},[_vm._l((_vm.links),function(item){return _c('div',{key:item.section,staticClass:"app-nav-link",class:{ active: _vm.$route.meta.section === item.section },on:{"click":function($event){_vm.$route.meta.section === item.section
        ? null
        : _vm.$router.push({ name: item.name })}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),_vm._v(" "+_vm._s(_vm.test)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }